import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppState } from 'src/app/App.state';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { ConciliacaoFormComponent } from 'src/app/global/forms/conciliacao-form/conciliacao-form.component';
import {
  ConciliacaoBancariaDinheiroEvent,
  VisualizarConciliacaoBancariaDinheiroFilterOptions,
} from 'src/app/global/lists/visualizar-conciliacao-dinheiro-list/visualizar-conciliacao-dinheiro-list.component';
import { DialogService } from 'src/app/global/services/dialog.service';
import { ConciliacaoBancariaDinheiro } from '../../domain/conciliacao-bancaria-dinheiro.model';
import { ConciliacaoDTO } from '../../domain/dto/conciliacao.dto';
import { Page } from '../../domain/return-api.model';
import { ConciliacaoBancariaDinheiroService } from '../../services/conciliacao-bancaria-dinheiro.service';

@Component({
  selector: 'app-conciliacao-dinheiro',
  templateUrl: './conciliacao-dinheiro.component.html',
  styleUrls: ['./conciliacao-dinheiro.component.css'],
})
export class ConciliacaoDinheiroComponent implements OnInit {
  private static DELETE_ACTION = 'Deletar';
  private static EDITAR_ACTION = 'Editar';

  queryOptions = new QueryOptions({ pageSize: 25 });

  page: Page<ConciliacaoBancariaDinheiro> = new Page();
  totalRecords: number = 0;
  valorTotal: number = 0;

  loading: boolean = false;

  constructor(
    private service: ConciliacaoBancariaDinheiroService,
    public appState: AppState,
    private dialog: MatDialog,
    private dialogService: DialogService,
  ) {
    const date = new Date();
    date.setHours(0, 0, 0);
    this.queryOptions.params = {
      dataInicio: date.getTime(),
      dataFim: new Date().getTime(),
    };
  }

  ngOnInit(): void { }

  list(pageNumber: number = 0): void {
    this.loading = true;
    this.appState.isLoading = true;
    this.queryOptions.pageNumber = pageNumber;

    const dataInicio: Date = new Date(this.queryOptions.params.dataInicio as number);
    dataInicio.setHours(0, 0, 0);
    const dataFim = new Date(this.queryOptions.params.dataFim as number);
    dataFim.setHours(23, 59, 59);

    const estadoId = this.queryOptions.params.estadoId as number;
    const postoUID = this.queryOptions.params.postoUID as string;
    const processado = this.queryOptions.params.processado as boolean;
    const rotaId = this.queryOptions.params.rotaId as number;

    this.queryOptions.params = {
      dataInicio: dataInicio.getTime(),
      dataFim: dataFim.getTime(),
      estadoId,
      postoUID,
      processado,
      rotaId,
    };

    this.service.findAllPageable(this.queryOptions).subscribe((response: Page<ConciliacaoBancariaDinheiro>) => {
      this.loading = false;
      this.appState.isLoading = false;

      this.totalRecords = response.totalElements;
      this.service.getValorTotal(this.queryOptions).subscribe((resp: number) => {
        this.valorTotal = resp;
      });

      response.content = this.mapearAcoes(response.content);
      this.page = response;
    });
  }

  mapearAcoes(arquivos: ConciliacaoBancariaDinheiro[]): ConciliacaoBancariaDinheiro[] {
    const mapearAcoes = (arquivo: ConciliacaoBancariaDinheiro): ConciliacaoBancariaDinheiro => {
      const acoes = [];
      acoes.push(ConciliacaoDinheiroComponent.DELETE_ACTION);
      acoes.push(ConciliacaoDinheiroComponent.EDITAR_ACTION);
      return { ...arquivo, acoes };
    };

    return arquivos?.map(mapearAcoes) ?? [];
  }

  onFilter(options: VisualizarConciliacaoBancariaDinheiroFilterOptions): void {
    const date = new Date();
    date.setHours(0, 0, 0, 0);

    this.queryOptions.params = {
      dataInicio: options.dataInicial ? options.dataInicial.getTime() : date.getTime(),
      dataFim: options.dataFinal ? options.dataFinal.getTime() : date.getTime(),
      estadoId: options.estadoId,
      postoUID: options.postoUID,
      rotaId: options.rotaId,
    };

    this.list();
  }

  async onAcaoClick(event: ConciliacaoBancariaDinheiroEvent) {
    const actions = new Map<string, (conciliacao: ConciliacaoBancariaDinheiro) => void>()
      .set(ConciliacaoDinheiroComponent.DELETE_ACTION, (conciliacao: ConciliacaoBancariaDinheiro) => {
        this.dialogService.confirmDialog('Deseja realmente deletar esse registro?', () => this.onDelete(conciliacao));
      })
      .set(ConciliacaoDinheiroComponent.EDITAR_ACTION, (conciliacao: ConciliacaoBancariaDinheiro) => {
        this.onEdit(conciliacao);
      });

    actions.get(event.acao)(event.conciliacao);
  }

  async realizarAssociacao(conciliacaoBancariaDinheiro: ConciliacaoBancariaDinheiroEvent): Promise<void> { }

  onMenuAcaoClick(event: string) { }

  onNovo(): void {
    this.dialog
      .open(ConciliacaoFormComponent, {
        data: {
          action: 'novo',
          type: 'dinheiro',
          usuario: null,
        },
        width: '300px',
      })
      .afterClosed()
      .subscribe((result: ConciliacaoDTO) => {
        if (result) {
          let dinheiro = new ConciliacaoBancariaDinheiro();
          dinheiro.data = result.data;
          dinheiro.responsavel = result.responsavel;
          dinheiro.name = result.name;
          dinheiro.tipoConciliacaoBancaria = result.tipoConciliacaoBancaria;
          dinheiro.banco = result.banco;
          dinheiro.valor = result.valor;
          dinheiro.identificador = result.identificador;

          this.service.create(dinheiro).subscribe(
            () => {
              this.appState.isLoading = false;
              this.dialogService.feedbackSuccess('Operação realizada com sucesso!');
              this.list();
            },
            // tslint:disable-next-line: typedef
            (error) => {
              this.appState.isLoading = false;
              console.error(error);
              this.dialogService.feedbackError('Ocorreu um erro ao criar registro!');
              this.list();
            },
          );
        }
      });
  }

  onEdit(conciliacao: ConciliacaoBancariaDinheiro): void {
    this.dialog
      .open(ConciliacaoFormComponent, {
        data: {
          action: 'update',
          type: 'dinheiro',
          conciliacao: ConciliacaoBancariaDinheiro.toConciliacaoDTO(conciliacao),
        },
        width: '300px',
      })
      .afterClosed()
      .subscribe((result: ConciliacaoDTO) => {
        if (result) {
          let doc = ConciliacaoDTO.toConciliacaoDinheiro(result);

          this.service.create(doc).subscribe(
            () => {
              this.appState.isLoading = false;
              this.dialogService.feedbackSuccess('Operação realizada com sucesso!');
              this.list();
            },
            // tslint:disable-next-line: typedef
            (error) => {
              this.appState.isLoading = false;
              console.error(error);
              this.dialogService.feedbackError('Ocorreu um erro ao atualizar registro!');
              this.list();
            },
          );
        }
      });
  }

  onDelete(conciliacao: ConciliacaoBancariaDinheiro): void {
    this.service.delete(conciliacao).subscribe((response) => {
      this.dialogService.feedbackInfo('Registro apagado.'), this.list();
      (error: HttpErrorResponse) => {
        this.dialogService.feedbackError('Ocorreu um erro ao apagar o registro: ' + error.message);
      };
    });
  }

  onLoadArquivosPage(pageNumber: number): void {
    this.list(pageNumber);
  }
}
